/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Paper, TextField, Typography, Button, IconButton, Tooltip, Collapse, Divider, FormControl, FormControlLabel, FormHelperText, Switch, Tabs, Tab, Input, InputLabel, InputAdornment, CircularProgress } from '@material-ui/core';

import { Add, Delete, Edit, Check, ExpandLess, ExpandMore, ArrowDownward, ArrowUpward, Today, ConfirmationNumber, Visibility, VisibilityOff, Settings, FindInPage, Attachment } from '@material-ui/icons'

import { Autocomplete, ToggleButton, ToggleButtonGroup } from '@material-ui/lab'
import Actions from '../../../../../fluid/Actions/ActionFactory';

import DraggableList from 'react-draggable-list'

import RecoSourceDetail from './RecoSourceDetail'
import RecoSource from './RecoSource'
import Filter from '../../../components/Filter/Filter'
import CTAConfig from '../../../components/CTAConfig/CTAConfig';
import ExternalSources from '../../../components/ExternalSources/ExternalSources';

const clone = require('rfdc')()

let equal = require('deep-equal')

const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
})(Tabs);
  
const AntTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(2),
        padding : theme.spacing(1),
        fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
        color: '#40a9ff',
        opacity: 1,
        },
        '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
        color: '#40a9ff',
        },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);

const styles = theme => ({

})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

class FieldItem extends Component {
    state = {
        col_name : null
    }

    componentDidMount () {
        const {item, itemSelected, dragHandleProps, commonProps } = this.props;
        this.setState({...this.state, col_name : item.col_name})
    }

    render () {
        const {item, itemSelected, dragHandleProps, commonProps } = this.props;
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper style = {{width : '100%', height : '100%', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', backgroundColor : '#FAFBFC'}}>
                    <div style = {{width : '7px', height : '15px', marginRight : '10px', backgroundColor : '#2296f3'}} {...dragHandleProps}></div>
                    <div style = {{flexGrow : 1}}>
                        <Typography variant = 'body2'>{item.name}</Typography>
                    </div>
                    <TextField
                        style = {{ width : '250px', marginRight : '20px'}}
                        label = "Column Name"
                        size = 'small'
                        variant = 'filled'
                        value = {this.state.col_name}
                        onChange = {(event) => this.setState({...this.state, col_name : event.target.value})}
                        InputProps = {{
                            onBlur : () => commonProps.updateField(item.name, 'col_name', this.state.col_name)
                        }}
                    />
                    <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <div style = {{marginRight : '20px'}}>
                            <ToggleButtonGroup
                                value = {item.type}
                                exclusive
                                size = 'small'
                                onChange = {(event, value) => commonProps.updateField(item.name, 'type', value)}
                            >
                                <ToggleButton value = 'date-time'>
                                    <Tooltip title = 'Date Field'>
                                        <Today fontSize = 'small' color = {item.type === 'date-time' ? 'primary' : 'inherit'}/>
                                    </Tooltip>
                                </ToggleButton>
                                <ToggleButton value = 'id'>
                                    <Tooltip title = 'ID Field'>
                                        <ConfirmationNumber fontSize = 'small' color = {item.type === 'id' ? 'primary' : 'inherit'}/>
                                    </Tooltip>
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        <div style = {{marginRight : '20px'}}>
                            <ToggleButtonGroup
                                value = {item.visibility}
                                exclusive
                                size = 'small'
                                onChange = {(event, value) => commonProps.updateField(item.name, 'visibility', value)}
                            >
                                <ToggleButton value = 'show'>
                                    <Tooltip title = 'Visibility'>
                                        {item.visibility === 'show' ? 
                                            <Visibility fontSize = 'small' color = {item.visibility === 'show' ? 'primary' : 'inherit'}/> : 
                                            <VisibilityOff fontSize = 'small'/> 
                                        }
                                    </Tooltip>
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        <div style = {{marginRight : '20px'}}>
                            <ToggleButtonGroup
                                value = {item.sort}
                                exclusive
                                size = 'small'
                                onChange = {(event, value) => commonProps.updateField(item.name, 'sort', value)}
                            >
                                <ToggleButton value = "desc">
                                    <Tooltip title = 'Descending Sort'>
                                        <ArrowDownward fontSize = 'small'/>
                                    </Tooltip>
                                </ToggleButton>
                                <ToggleButton value = "asc">
                                    <Tooltip title = 'Ascending Sort'>
                                        <ArrowUpward fontSize = 'small'/>
                                    </Tooltip>
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        <div style = {{marginRight : '10px'}}>
                            <ToggleButtonGroup
                                value = {item.get_attachments}
                                exclusive
                                size = 'small'
                                onChange = {(event, value) => commonProps.updateField(item.name, 'get_attachments', value)}
                            >
                                <ToggleButton value = {true}>
                                    <Tooltip title = 'Get Field Attachments'>
                                        <Attachment fontSize = 'small' color = {item.get_attachments ? 'primary' : 'inherit'}/>
                                    </Tooltip>
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        <div style = {{width : '25vw', marginRight : '10px', marginBottom : '7px'}}>
                            <Autocomplete
                                fullWidth
                                limitTags={5}
                                multiple
                                id="tags-standard"
                                options={commonProps.file_types}
                                value = {item.include_file_extensions ? item.include_file_extensions : []}
                                getOptionLabel={(option) => option}
                                disabled = {!item.get_attachments}
                                onChange = {(event, newValue) => commonProps.updateField(item.name, 'include_file_extensions', newValue)}
                                ChipProps = {{size : 'small'}}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="standard"
                                        label="Field Attachment File Types"
                                        size="small"
                                    />
                                )}
                            />
                        </div>
                        <div>
                            <ToggleButtonGroup
                                value = {item.process_attachments}
                                exclusive
                                size = 'small'
                                onChange = {(event, value) => commonProps.updateField(item.name, 'process_attachments', value)}
                            >
                                <ToggleButton value = {true}>
                                    <Tooltip title = 'Process Field Attachments'>
                                        <FindInPage fontSize = 'small' color = {item.process_attachments ? 'primary' : 'inherit'}/>
                                    </Tooltip>
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                    </div>
                </Paper>
            </ThemeProvider>
        )
    }
}

class Case extends Component {
    state = {
        edit : false,
        name : null,
        icName : null,
        iuName : null,
        url : null,
        ticket_url : null,
        columns : null,
        reco_sources : [],
        show_class : null,
        get_global_attachments: false,
        all_file_types : [],
        global_attachment_file_types : [],
        loading_file_types : false,
        process_global_attachments: false,
        ic_list : [],
        ic_object_list : [],
        ic_loading : false,
        ic_open : false,
        ic_ops : [],
        iu_list : [],
        iu_loading : false,
        iu_open : false,
        show_settings : false,
        fields_in_scope : null,
        type : null,
        adding_source : false,
        selected_source : null,
        setting_tab_index : 0,
        show_table : true,
        show_ticket : true,
        show_back : true,
        show_in_sidebar : true,
        reference_field : null,
        show_app_bar : true,
        copy_to_parent : false,
        average_record_size : null,
        max_batch_threshold : null,
        encode_uri : true,
        loading_relevant_ICs : false,
        filters : [],
        icObjects : [],
        cta_config : [],
        external_sources : [],
        screen_cta_config : {},
        error_message : ''
    }

    container = React.createRef()

    componentWillMount () {
        this.generateStateFromConfig()
    }

    generateStateFromConfig = () => {
        console.log("Queue Config Props : ", this.props.config)
        this.setState({
            ...this.state,
            name : this.props.config.name,
            icName : this.props.config.default_params !== null ? this.props.config.default_params.icName : null,
            iuName : this.props.config.default_params !== null ? this.props.config.default_params.iuName : null, 
            url : this.props.config.route,
            columns : this.props.config.default_params !== null ? this.props.config.default_params.columns : null,
            reco_sources : this.props.config.default_params !== null ? this.props.config.default_params.reco_sources ? this.props.config.default_params.reco_sources : [] : [],
            show_class : this.props.config.default_params !== null ? this.props.config.default_params.show_class : null,
            get_global_attachments : this.props.config.default_params !== null ? this.props.config.default_params.get_global_attachments ? this.props.config.default_params.get_global_attachments : false : false,
            global_attachment_file_types : this.props.config.default_params !== null ? this.props.config.default_params.global_attachment_file_types ? this.props.config.default_params.global_attachment_file_types : [] : [],
            process_global_attachments : this.props.config.default_params !== null ? this.props.config.default_params.process_global_attachments ? this.props.config.default_params.process_global_attachments : false : false,
            show_table : this.props.config.default_params !== null ? this.props.config.default_params.show_table : true,
            show_ticket : this.props.config.default_params !== null ? this.props.config.default_params.show_ticket : true,
            show_back : this.props.config.default_params !== null ? this.props.config.default_params.show_back : true,
            show_app_bar : this.props.config.default_params !== null ? this.props.config.default_params.show_app_bar : true,
            show_in_sidebar : this.props.config.show_in_sidebar !== undefined ? this.props.config.show_in_sidebar : true,
            reference_field : this.props.config.default_params !== null ? this.props.config.default_params.reference_field : null,
            copy_to_parent : this.props.config.default_params !== null ? this.props.config.default_params.copy_to_parent : false,
            average_record_size : this.props.config.default_params !== null ? this.props.config.default_params.average_record_size : null,
            max_batch_threshold : this.props.config.default_params !== null ? this.props.config.default_params.max_batch_threshold : null,
            filters : this.props.config.default_params !== null && this.props.config.default_params.filters !== undefined ? this.props.config.default_params.filters : [],
            cta_config : this.props.config.default_params !== null && this.props.config.default_params.cta_config !== undefined ? this.props.config.default_params.cta_config : [],
            external_sources : this.props.config.default_params !== null ? this.props.config.default_params.external_sources ? this.props.config.default_params.external_sources : [] : [],
            screen_cta_config : this.props.config.default_params !== null ? this.props.config.default_params.screen_cta_config ? this.props.config.default_params.screen_cta_config : null : null
        }, () => {
            console.log("Queue Config State : ", this.state)
        })
    }

    getICs = () => {
        this.setState({...this.state, ic_loading : true}, () => {
            Actions ('http_request', {
                url : "/sainapse/information_channel",
                method : "get",
                data : {}
            }).then(res => {
                let ic_list = res.data.result.map(ic => ic.name)
                this.setState({...this.state, ic_loading : false, ic_list : ic_list, ic_object_list : res.data.result})
            }).catch(err => {
                this.setState({...this.state, ic_loading : false, ic_list : [], ic_object_list : null})
            })
        })
    }

    getIUs = (ic_name) => {
        this.setState({...this.state, iu_loading : true}, () => {
            Actions ('http_request', {
                url : "/sainapse/information_channel/" + ic_name + "/information_unit/",
                method : "get",
                data : {}
            }).then(res => {
                let iu_list = res.data.result.map(iu => iu.name)
                this.setState({...this.state, iu_loading : false, iu_list : iu_list})
            }).catch(err => {
                this.setState({...this.state, iu_loading : false, ic_list : []})
            })
        })
    }

    updateState = (state_key, value) => {
        this.setState({...this.state, [state_key] : value}, () => {
            if (state_key === 'iuName') {
                Actions('http_request', {
                    url : "/sainapse/information_channel/" + this.state.icName + "/information_unit/" + this.state.iuName + "/field_in_scope",
                    method : "get",
                    data : {}
                }).then(res => {
                    let fields = []
                    let fields_in_scope = res.data.result.map(field => {
                        return field.name
                    })
                    if (Array.isArray(res.data.result)) {
                        fields = res.data.result.map(field => {
                            let new_field = {
                                name : field.name,
                                sort : null,
                                type : null,
                                col_name : null,
                                visibility : 'show',
                                get_attachments : false,
                                include_file_extensions : [],
                                process_attachments : false
                            }
                            return new_field
                        })
                    }
                    console.log("Columns: ", fields)
                    this.setState({...this.state, columns : fields, fields_in_scope : fields_in_scope})
                })
            }
        })
    }

    saveSettings = () => {
        let id_index = this.state.columns.findIndex(column => column.type === 'id')
        let date_index = this.state.columns.findIndex(column => column.type === 'date-time')
        let sorted_column_index = this.state.columns.findIndex(column => column.sort !== null)
        if(id_index === -1 || date_index === -1 || sorted_column_index === -1) {
            let error_message = 'Queue configuration must have: 1. Data field with sorting options 2. ID field'
            this.setState({...this.state, error_message : error_message})
        } else {
            let error_message = ''
            this.setState({...this.state, error_message : error_message},() => this.props.update(this.generateConfigFromState()))
        }
    }

    cancelSettings = () => {
        if (this.state.name === null || this.state.error_message !== '') {
            this.setState({...this.state, show_settings : false}, () => {
                this.props.delete(this.props.config)
            })
        } else {
            this.setState({...this.state, show_settings : false}, () => {
                this.generateStateFromConfig()
                this.props.update(this.props.config)
            })
        }
    }

    updateRecoSources = (reco_source) => {
        let reco_sources = this.state.reco_sources !== null ? [...this.state.reco_sources] : []
        if (reco_sources.length > 0) {
            let existing_source_index = reco_sources.findIndex(source => source.ic_name === reco_source.ic_name)
            if (existing_source_index === -1) {
                reco_sources.push(reco_source)
            } else {
                reco_sources[existing_source_index] = reco_source
            }
        } else {
            reco_sources.push(reco_source)
        }
        this.setState({...this.state, reco_sources : reco_sources})
    }

    updateICName = (value) => {
        this.setState({
            ...this.state,
            icName : value,
            iuName : null,
            cta_config : []
        }, () => this.getICDetails())
    }

    getICDetails = () => {
        Actions('http_request', {
            url : "/sainapse/information_channel/" + this.state.icName,
            method : "get",
            data : {}
        }).then(res => {
            let ic = res.data.result
            let ic_ops = ic.operations.map(op => op)
            this.setState({...this.state, ic_ops : ic_ops, show_class : ic_ops.includes("Classify") ? false : null}, () => console.log("Case State : ", this.state))
        })
    }

    generatePath = (name, icName, iuName, type) => {
        if (name !== null) {
            let path = name.toLowerCase()
            path = path.replace(/ /g,"_")
            path = '/' + path
            if (type === 'query') {
                if (icName !== null) {
                    path = path +'?icName=' + encodeURI(icName)
                    if (iuName !== null) {
                        path = path + '&iuName=' + encodeURI(iuName)
                    }
                }
            }

            if (type === 'record') {
                path = path + '?recordID='
            }

            return path
        } else {
            return '/_'
        }
    }

    generateConfigFromState = () => {
        let config = clone(this.props.config)
        config.name = this.state.name
        config.route = this.generatePath(this.state.name, this.state.icName, this.state.iuName)
        config.default_params.icName = this.state.icName
        config.default_params.iuName = this.state.iuName
        config.default_params.columns = this.state.columns
        config.default_params.reco_sources = this.state.reco_sources
        config.default_params.show_class = this.state.show_class
        config.default_params.get_global_attachments = this.state.get_global_attachments
        config.default_params.global_attachment_file_types = this.state.global_attachment_file_types
        config.default_params.process_global_attachments = this.state.process_global_attachments
        config.default_params.show_table = this.state.show_table
        config.default_params.show_ticket = this.state.show_ticket
        config.default_params.show_back = this.state.show_back
        config.default_params.reference_field= this.state.reference_field
        config.default_params.show_app_bar= this.state.show_app_bar
        config.show_in_sidebar = this.state.show_in_sidebar
        config.default_params.copy_to_parent = this.state.copy_to_parent
        config.default_params.average_record_size = this.state.average_record_size
        config.default_params.max_batch_threshold = this.state.max_batch_threshold
        config.default_params.filters = this.state.filters
        config.default_params.cta_config = this.state.cta_config
        config.default_params.external_sources = this.state.external_sources
        config.default_params.screen_cta_config = this.state.screen_cta_config
        console.log("Generating Queue Config : ", config)

        return config
    }

    renderCaseEdit = () => {
        return (
            <div style = {{width : '100%', display : 'flex', flexDirection : 'row', flexWrap : 'wrap'}}>
                <div style = {{width : '90%', display : 'flex', flexDirection : 'row'}}>
                    <div style = {{flex : '1 0 22%', margin : '5px', borderRadius : '5px', padding : '5px'}}>
                        <TextField
                            style = {{width : '100%'}}
                            label = "Name"
                            value = {this.state.name}
                            onChange = {(event) => {
                                if (event.target.value !== "") {
                                    this.updateState('name', event.target.value)
                                } else {
                                    this.updateState('name', null)
                                }
                            }}
                            variant = 'filled'
                            size = 'small'
                        />
                    </div>
                    <div style = {{flex : '1 0 22%', margin : '5px', border : '1px solid rgba(0,0,0,0.12)', borderRadius : '5px', padding : '5px'}}>
                        <Typography variant = 'subtitle2' color = 'textSecondary'>URL</Typography>
                        <Typography variant = 'caption' color = 'textSecondary'>{window.location.origin + '/#' + this.generatePath(this.state.name, this.state.icName, this.state.iuName, 'url')}</Typography>
                    </div>
                    <div style = {{flex : '1 0 22%', margin : '5px', borderRadius : '5px', padding : '5px'}}>
                        <Autocomplete
                            id="tags-standard"
                            options={this.state.ic_list}
                            value = {this.state.icName}
                            onOpen = {() => this.getICs()}
                            onChange = {(event, newValue) => this.updateICName(newValue)}
                            loading = {this.state.ic_loading}
                            disabled = {this.state.name === null || this.state.name === ""}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                label="Default Information Channel"
                                variant = 'filled'
                                size = 'small'
                                />
                            )}
                        />
                    </div>
                    <div style = {{flex : '1 0 22%', margin : '5px', borderRadius : '5px', padding : '5px'}}>
                        <Autocomplete
                            id="tags-standard"
                            options={this.state.iu_list}
                            value = {this.state.iuName}
                            onOpen = {() => this.getIUs(this.state.icName)}
                            onChange = {(event, newValue) => this.updateState('iuName', newValue)}
                            loading = {this.state.iu_loading}
                            disabled = {this.state.name === null || this.state.name === ""}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                label="Default Information Unit"
                                variant = 'filled'
                                size = 'small'
                                />
                            )}
                        />
                    </div>
                </div>
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row-reverse', alignItems : 'right'}}>
                    {/* <Button
                        variant = 'contained'
                        size = 'small'
                        color = 'primary'
                        onClick = {(event) => this.props.update(this.generateConfigFromState())}
                        startIcon = {<Check/>}
                    >
                        Submit
                    </Button> */}
                    {this.renderButtons(this.props.editing_id === this.props.config.id ? true : false)}
                </div>
            </div>
        )
    }

    copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
    }

    updateColumnField = (name, key_name, value) => {
        console.log('Name : ' + name  + ' Key : ' + key_name + ' Value: ' + value)
        let columns = clone(this.state.columns)
        let field_index = columns.findIndex(field => field.name === name)
        let column = columns[field_index]
        column[key_name] = value

        this.setState({...this.state, columns : columns})
    }

    renderTableColumns = () => {
        if (this.state.iuName !== null) {
            if (this.state.columns !== null) {
                return (
                    <div ref = {this.container} style = {{width: '95vw', padding : '5px', backgroundColor : '#F0F0F0', maxHeight : '55vh', overflow : 'auto'}}>
                        <DraggableList
                            list = {this.state.columns}
                            itemKey = 'name'
                            template = {FieldItem}
                            onMoveEnd = {(newList) => this.updateState('columns', newList)}
                            commonProps = {{
                                updateField : (name, key ,value) => this.updateColumnField(name, key, value),
                                file_types : this.props.file_types
                            }}
                            container = {() => this.container.current}
                        />
                    </div>
                )
            } else {
                return (
                    <Typography variant = 'caption' color = 'secondary'>No Fields in scope for this IU</Typography>
                )
            }
        }
    }

    renderSearchSettings = () => {
        return (
            <div style = {{width : '100%', padding : '5px'}}>
                {this.renderGetGlobalAttachments()}
                {this.renderProcessGlobalAttachments()}
                {this.renderClassSwitch()}
                <Divider style = {{marginTop : '2px', marginBottom : '2px' }}/>
                {this.renderRecoSourcesContainer()}
            </div>
        )
    }

    getFileTypes = () => {
        this.setState({...this.state, loading_file_types : true}, () => {
            Actions('http_request', {
                url: "/sainapse/file_types",
                method: "get",
                data: {}
            }).then(res => {
                let file_types = res.data.result.map(file_type => file_type.type)
                this.setState({...this.state, all_file_types : file_types, loading_file_types: false})
            })
        })
    }

    renderGetGlobalAttachments = () => {
        return (
            <div>
                <FormControl style = {{ padding : '5px', display: 'block'}}>
                    <FormControlLabel
                        style = {{width : '100%'}}
                        control = {<Switch color = "primary" checked={this.state.get_global_attachments} onChange={(event) => this.updateState("get_global_attachments", event.target.checked)} name="get_global_attachments" />}
                        label = {<Typography variant = 'body2'>Get Global Attachments</Typography>}
                    />
                    <FormHelperText>
                        Would you like to fetch global attachments? 
                    </FormHelperText>
                </FormControl>
                <div>
                    <Autocomplete
                        id="global-file-types"
                        fullWidth
                        multiple
                        options={this.state.all_file_types}
                        value = {this.state.global_attachment_file_types}
                        onOpen = {() => this.getFileTypes()}
                        onChange = {(event, newValue) => this.updateState("global_attachment_file_types", newValue)}
                        loading = {this.state.loading_file_types}
                        disabled = {!this.state.get_global_attachments}
                        ChipProps = {{size : 'small'}}
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            label="Global Attachment File Types"
                            variant = 'standard'
                            size = 'small'
                            />
                        )}
                    />
                </div>
            </div>
        )
    }

    renderProcessGlobalAttachments = () => {
        return (
            <FormControl style = {{ padding : '5px', display: 'block'}}>
                <FormControlLabel
                    style = {{width : '100%'}}
                    control = {
                        <Switch 
                            color = "primary" 
                            disabled = {!this.state.get_global_attachments}
                            checked={this.state.process_global_attachments} 
                            onChange={(event) => this.updateState("process_global_attachments", event.target.checked)} 
                            name="process_global_attachments" 
                        />
                    }
                    label = {<Typography variant = 'body2'>Process Global Attachments</Typography>}
                />
                <FormHelperText>
                    Would you like to process global attachments and use the extracted content for inferencing? 
                </FormHelperText>
            </FormControl>
        )
    }

    renderClassSwitch = () => {
        return (
            <FormControl style = {{ padding : '5px'}}>
                <FormControlLabel
                    style = {{width : '100%'}}
                    control = {<Switch color = "primary" checked={this.state.show_class} onChange={(event) => this.updateState("show_class", event.target.checked)} name="show_class" />}
                    disabled = {this.state.show_class === null ? true : false}
                    label = {<Typography variant = 'body2'>Show Classification Results</Typography>}
                />
                <FormHelperText>
                    {this.state.show_class === null ? "Classification Operation is not configured for " + this.state.icName + "." : "Show Classification  results along with recommendations."}
                </FormHelperText>
            </FormControl>
        )
    }

    renderRecoSourcesContainer = () => {
        if (this.state.iuName !== null) {
            return (
                <div style = {{width : '100%', marginTop : '10px'}}>
                    <Typography style = {{display : 'block'}} variant = 'body2' color = 'primary'>Additional Information Channels to search across. <em>(In addition to the default IC)</em></Typography>
                    {this.renderRecoSources()}
                </div>
            )
        }
    }

    renderRecoSources = () => {
        let reco_source_list = this.state.reco_sources !== null ? this.state.reco_sources : []

        let reco_sources = reco_source_list.map(source => {
            return (
                <RecoSource source = {source} delete_source = {(ic_name) => this.deleteSource(ic_name)} select_source = {(ic_name) => this.selectSource(ic_name)}/>
            )
        })

        return (
            <div style = {{width : '100%', marginTop : '5px'}}>
                {reco_sources}
                <Tooltip title = "Add Information Channel">   
                    <IconButton
                        size = 'small'
                        color = 'primary'
                        disabled = {this.state.adding_source}
                        onClick = {() => this.updateState("adding_source", true)}
                    >
                        <Add fontSize = 'small'/>
                    </IconButton>
                </Tooltip>
            </div>
        )
    }

    addRecoSourceDialog = () => {
        return (
            <RecoSourceDetail 
                open = {this.state.adding_source} 
                source = {null}
                case_screen = {this.state.name}
                onClose = {this.closeAddRecoSourceDialog}
                ic_list = {this.state.ic_list}
                reco_sources = {this.state.reco_sources}
                default_ic_name = {this.state.icName}
                default_iu_name = {this.state.iuName}
                update_source = {(reco_source) => this.updateRecoSources(reco_source)}
            />
        )
    }

    closeAddRecoSourceDialog = () => {
        this.setState({...this.state, adding_source : false, selected_source : null})
    }

    viewRecoSourceDialog = () => {
        if (this.state.selected_source !== null) {
            return (
                <RecoSourceDetail 
                    open = {this.state.selected_source !== null ? true : false} 
                    source = {this.state.selected_source}
                    case_screen = {this.state.name}
                    onClose = {this.closeAddRecoSourceDialog}
                    ic_list = {this.state.ic_list}
                    reco_sources = {this.state.reco_sources}
                    default_ic_name = {this.state.icName}
                    default_iu_name = {this.state.iuName}
                    update_source = {(reco_source) => this.updateRecoSources(reco_source)}
                />
            )
        }
    }

    selectSource = (ic_name) => {
        let selected_source = this.state.reco_sources.find(source => source.ic_name === ic_name)
        this.setState({...this.state, selected_source : selected_source})
    }

    deleteSource = (ic_name) => {
        let new_state = clone(this.state)
        let sources = new_state.reco_sources
        let cta_config = new_state.cta_config
        let source_index = sources.findIndex(source => source.ic_name === ic_name)
        let cta_config_index = cta_config.findIndex(config => config.ic_name === ic_name)
        cta_config.splice(cta_config_index,1)
        sources.splice(source_index, 1)

        this.setState({...new_state})
    }

    renderCase = () => {
        return (
            <div style = {{width : '100%', display : 'flex', flexDirection : 'row', flexWrap : 'wrap'}}>
                <div style = {{width : '90%', display : 'flex', flexDirection : 'row'}}>
                    {/* <div style = {{margin : '5px', padding : '5px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
                        <Tooltip title = 'Show Settings' >
                            <IconButton 
                                disabled = {this.state.icName !== null && this.state.iuName !== null ? false : true} 
                                onClick = {() => this.updateState('show_settings', !this.state.show_settings)}
                                color = {this.state.show_settings ? 'primary' : ''}
                            >
                                <Settings fontSize = 'small'/>
                            </IconButton>
                        </Tooltip>
                    </div> */}
                    <div style = {{flex : '1 0 22%', margin : '5px', border : '1px solid rgba(0,0,0,0.12)', borderRadius : '5px', padding : '5px'}}>
                        <Typography variant = 'subtitle2' color = 'primary'>Name</Typography>
                        <Typography variant = 'body2'>{this.props.config.name}</Typography>
                    </div>
                    <div style = {{flex : '1 0 22%', margin : '5px', border : '1px solid rgba(0,0,0,0.12)', borderRadius : '5px', padding : '5px'}}>
                        <Typography variant = 'subtitle2' color = 'primary'>URL</Typography>
                        <Tooltip title = 'Click to copy'>
                            <Typography onClick = {(event) => this.copyToClipboard(this.props.config.route !== null ? window.location.origin + '/#' + this.props.config.route : null)} style = {{cursor : 'pointer'}} variant = 'caption'>{this.props.config.route !== null ? window.location.origin + '/#' + this.props.config.route : null}</Typography>
                        </Tooltip>
                    </div>
                    <div style = {{flex : '1 0 22%', margin : '5px', border : '1px solid rgba(0,0,0,0.12)', borderRadius : '5px', padding : '5px'}}>
                        <Typography variant = 'subtitle2' color = 'primary'>Default Information Channel</Typography>
                        <Typography variant = 'body2'>{this.props.config.default_params.icName}</Typography>
                    </div>
                    <div style = {{flex : '1 0 22%', margin : '5px', border : '1px solid rgba(0,0,0,0.12)', borderRadius : '5px', padding : '5px'}}>
                        <Typography variant = 'subtitle2' color = 'primary'>Default Information Unit</Typography>
                        <Typography variant = 'body2'>{this.props.config.default_params.iuName}</Typography>
                    </div>
                </div>
                <div style = {{width : '10%', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'space-around'}}>
                    <Tooltip title = 'Show Settings' >
                        <IconButton 
                            disabled = {this.state.icName !== null && this.state.iuName !== null ? false : true} 
                            onClick = {() => this.updateState('show_settings', !this.state.show_settings)}
                            color = {this.state.show_settings ? 'primary' : ''}
                        >
                            <Settings fontSize = 'small'/>
                            {/* {this.state.show_settings ? <ExpandLess fontSize = 'small'/> : <ExpandMore fontSize = 'small'/>} */}
                        </IconButton>
                    </Tooltip>
                    <Tooltip title = 'Edit' >
                        <IconButton onClick = {() => this.props.enable_edit(this.props.config)}>
                            <Edit fontSize = 'small'/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title = 'Delete'>
                        <IconButton color = 'secondary' onClick = {() => this.props.delete(this.props.config)}>
                            <Delete fontSize = 'small'/>
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
        )
    }

    // renderSettings = () => {
    //     return (
            
    //             <div style = {{width : '100%', padding : '5px'}}>
    //                 <Typography variant = 'subtitle1'>Settings</Typography>
    //                 <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
    //                 <div style = {{width : '100%', padding : '5px'}}>
    //                     <Typography style = {{display : 'block'}} variant = 'subtitle2'>Deep Links</Typography>
    //                 </div>
    //                 <div style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>
    //                     <div style = {{margin : '5px', borderRadius : '5px', border : '1px solid rgba(0,0,0,0.12)', padding : '10px'}}>
    //                         <Typography style = {{display : 'block'}} variant = 'body2' color = 'primary'>URL <em>(With Query Params)</em></Typography>
    //                         <Tooltip title = 'Click to copy'>
    //                             <Typography onClick = {(event) => this.copyToClipboard(window.location.origin + '/#' + this.generatePath(this.state.name, this.state.icName, this.state.iuName, 'query'))} style = {{cursor : 'pointer'}} variant = 'body2'>{window.location.origin + '/#' + this.generatePath(this.state.name, this.state.icName, this.state.iuName, 'query')}</Typography>
    //                         </Tooltip>
    //                     </div>
    //                     <div style = {{margin : '5px' , borderRadius : '5px', border : '1px solid rgba(0,0,0,0.12)', padding : '10px'}}>
    //                         <Typography style = {{display : 'block'}} variant = 'body2' color = 'primary'>URL for individual record <em>(Append the record ID at the end)</em></Typography>
    //                         <Tooltip title = 'Click to copy'>
    //                             <Typography onClick = {(event) => this.copyToClipboard(window.location.origin + '/#' + this.generatePath(this.state.name, this.state.icName, this.state.iuName, 'record'))} style = {{cursor : 'pointer'}} variant = 'body2'>{window.location.origin + '/#' + this.generatePath(this.state.name, this.state.icName, this.state.iuName, 'record')}</Typography>
    //                         </Tooltip>
    //                     </div>
    //                 </div>
    //                 <Divider style = {{width : '100%', marginTop : '5px', marginBottom : '5px'}}/>
    //                 <div style = {{width : '100%', padding : '5px'}}>
    //                     <Typography style = {{display : 'block'}} variant = 'subtitle2'>View & Search Settings</Typography>
    //                 </div>
    //                 <div style = {{width : '100%', height : '40vh', display : 'flex', flexDirection : 'row'}}>
    //                     <div style = {{width : '60%', height : '40vh', padding : '5px', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
    //                         <Typography style = {{display : 'block', borderBottom : '1px solid rgba(0,0,0,0.12)'}} variant = 'body2' color = 'primary'>Queue Table Columns <em>(Drag and drop to reorder)</em></Typography>
    //                         {this.renderTableColumns()}
    //                     </div>
    //                     <div style = {{width : '40%', height : '40vh', padding : '5px', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
    //                         <Typography style = {{display : 'block', borderBottom : '1px solid rgba(0,0,0,0.12)'}} variant = 'body2' color = 'primary'>Search Settings</Typography>
    //                         {this.renderSearchSettings()}
    //                     </div>
    //                 </div>
    //                 {this.props.editing_id === this.props.config.id && <div style = {{width : '100%', display : 'flex', flexDirection : 'row-reverse'}}>
    //                     <div style = {{width : '5%', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'space-around'}}>
    //                         <Tooltip title = 'Submit' >
    //                             <IconButton color = 'primary' onClick = {() => {
    //                                 this.props.update(this.generateConfigFromState())
    //                             }}>
    //                                 <Check fontSize = 'small'/>
    //                             </IconButton>
    //                         </Tooltip>
    //                     </div>
    //                 </div>}
    //             </div>
    //     )
    // }

    renderTabContent = () => {
        switch (this.state.setting_tab_index) {
            case 0 :
              return this.renderTableConfig()
            case 1:
              return this.renderSearchConfig()
            case 2:
              return this.renderViewConfig()
            case 3:
                return this.renderEmbedConfig()
            case 4:
                return this.renderDeeplinks()
            case 5:
                return this.renderFilters()
            case 6:
                return this.renderExternalSources()
            case 7:
                return this.renderCTA()
            default :
              return null
        }
    }

    renderTableConfig = () => {
        return (
            <div style = {{width : '100%', maxHeight : '60vh', overflow : 'auto'}}>
                <Typography style = {{marginTop : '5px', marginBottom : '5px'}} variant = 'body2' color = 'textSecondary'><em>Modify the Queue table configurations below</em></Typography>
                <div style = {{display : 'flex', flexDirection : 'row', justifyContent : 'flex-start'}}>
                    <div style = {{width : '65%'}}>
                        {this.renderTableColumns()}
                    </div>
                </div>
            </div>
        )
    }

    renderSearchConfig = () => {
        return (
            <div style = {{width : '100%', maxHeight : '60vh', overflow : 'auto'}}>
                <Typography style = {{marginTop : '5px', marginBottom : '5px'}} variant = 'body2' color = 'textSecondary'>
                    <em>
                        Modify the search configurations here. You can choose to show classification results if they exist. You can also add multiple Information Channels to be searched across.
                    </em>
                </Typography>
                {this.renderSearchSettings()}
            </div>
        )
    }

    renderViewConfig = () => {
        return (
            <div style = {{width : '100%', maxHeight : '60vh', overflow : 'auto'}}>
                <Typography style = {{marginTop : '5px', marginBottom : '5px'}} variant = 'body2' color = 'textSecondary'>
                    <em>
                        Modify the elements that should be viewable.
                    </em>
                </Typography>
                <FormControl style = {{ padding : '5px'}}>
                    <FormControlLabel
                        style = {{width : '100%'}}
                        control = {
                            <Switch 
                                color = "primary" 
                                checked={this.state.show_table} 
                                onChange={(event) => this.updateState("show_table", event.target.checked)} 
                                name="show_table" />
                            }
                        label = {<Typography variant = 'body2'>Show Queue Table</Typography>}
                    />
                    <FormHelperText>
                        Shows the Queue Table. If switched off, hides the queue table and gets the recommendation for the record specified in the query params through recordID param.
                    </FormHelperText>
                </FormControl>
                <Divider style = {{marginTop : '3px', marginBottom : '3px'}} />
                <FormControl style = {{ padding : '5px'}}>
                    <FormControlLabel
                        style = {{width : '100%'}}
                        control = {
                            <Switch 
                                color = "primary" 
                                checked={this.state.show_ticket} 
                                onChange={(event) => this.updateState("show_ticket", event.target.checked)} 
                                name="show_ticket" />
                            }
                        label = {<Typography variant = 'body2'>Show Writable Record</Typography>}
                    />
                    <FormHelperText>
                        Shows the selected record in writeable form. If switched off, only recommendations will be displayed. Useful when you want to embed the queue recommendations in an external application.
                    </FormHelperText>
                </FormControl>
                <Divider style = {{marginTop : '3px', marginBottom : '3px'}} />
                <FormControl style = {{ padding : '5px'}}>
                    <FormControlLabel
                        style = {{width : '100%'}}
                        control = {
                            <Switch 
                                color = "primary" 
                                checked={this.state.show_back} 
                                onChange={(event) => this.updateState("show_back", event.target.checked)} 
                                name="show_back" />
                            }
                        label = {<Typography variant = 'body2'>Allow Navigating from Record to Queue</Typography>}
                    />
                    <FormHelperText>
                        This hides the back navigation button on the writeable record form. Useful when you do not want the user to view the entire Queue list, but only the record passed through query params. 
                    </FormHelperText>
                </FormControl>
                <Divider style = {{marginTop : '3px', marginBottom : '3px'}} />
                <FormControl style = {{ padding : '5px'}}>
                    <FormControlLabel
                        style = {{width : '100%'}}
                        control = {
                            <Switch 
                                color = "primary" 
                                checked={this.state.show_in_sidebar} 
                                onChange={(event) => this.updateState("show_in_sidebar", event.target.checked)} 
                                name="show_in_sidebar" />
                            }
                        label = {<Typography variant = 'body2'>Show in Sidebar</Typography>}
                    />
                    <FormHelperText>
                        This hides the link to this page in the sidebar menu. Useful when you want to restrict access to this screen from the menu, instead access only via deeplinks.
                    </FormHelperText>
                </FormControl>
                <Divider style = {{marginTop : '3px', marginBottom : '3px'}} />
                <Typography variant = 'body2'>Memory Allocation</Typography>
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>
                    <FormControl style = {{width : '20%', margin : '5px'}}>
                        <InputLabel>Average Record Size</InputLabel>
                        <Input
                            id="average-record-size"
                            type = "number"
                            value={this.state.average_record_size}
                            onChange={(event) => this.updateState("average_record_size", Number(event.target.value))}
                            endAdornment={<InputAdornment position="end">KB</InputAdornment>}
                            aria-describedby="standard-weight-helper-text"
                            inputProps={{
                                'aria-label': 'Average Record Size',
                            }}
                        />
                        <FormHelperText>Average size of an individual record.</FormHelperText>
                    </FormControl>
                    <FormControl style = {{width : '20%', margin : '5px'}}>
                        <InputLabel>Number of Records per page</InputLabel>
                        <Input
                            id="max-threshold"
                            type = "number"
                            value={Math.round(Number(this.state.max_batch_threshold) / Number(this.state.average_record_size))}
                            onChange={(event) => this.updateState("max_batch_threshold", Number(event.target.value) * Number(this.state.average_record_size))}
                            aria-describedby="standard-weight-helper-text"
                            inputProps={{
                                'aria-label': 'Average Record Size',
                            }}
                        />
                        <FormHelperText>Maximum number of records to display in a single page.</FormHelperText>
                    </FormControl>
                </div>
            </div>
        )
    }

    switchURLEncoding = () => {
        this.setState({...this.state, encode_uri : !this.state.encode_uri})
    }

    generateEmbedURL = () => {
        let base_url = window.location.origin + '/#' + this.props.config.route
        let embed_url = 'embed=true&'
        if (!this.state.show_app_bar) {
            embed_url = embed_url + 'showAppbar=false&'
        } 

        if (this.state.reference_field === null) {
            embed_url = embed_url + 'recordID='
        } else {
            embed_url = embed_url + 'referenceID='
        }
        let url

        if (this.state.encode_uri) {
            embed_url = encodeURIComponent(embed_url)
        }

        url = base_url + '?' +embed_url
        return url
    }

    getFieldsFromColumns = () => {
        let fields = this.state.columns.map(column => column.name)
        return fields
    }

    renderEmbedConfig = () => {
        return (
            <div style = {{width : '100%', maxHeight : '60vh', overflow : 'auto'}}>
                <Typography style = {{marginTop : '5px', marginBottom : '5px'}} variant = 'body2' color = 'textSecondary'>
                    <em>
                        Additional Settings for embedding this screen in an external app.
                    </em>
                </Typography>
                <Divider style = {{marginTop : '3px', marginBottom : '3px'}} />
                <div style = {{margin : '5px' , borderRadius : '5px', padding : '10px'}}>
                    <Typography style = {{display : 'block'}} variant = 'body2' color = 'primary'>
                        Embed URL
                        <Typography 
                            style = {{marginLeft: '15px', textDecoration : 'underline', cursor : 'pointer'}} 
                            color = 'secondary' 
                            display = 'inline' 
                            variant = 'caption'
                            onClick = {this.switchURLEncoding}
                        ><em>{this.state.encode_uri ? "Show Decoded URL" : "Show Encoded URL"}</em>
                        </Typography>
                    </Typography>
                    <Tooltip title = 'Click to copy' placement = 'bottom-start'>
                        <Typography 
                            onClick = {(event) => this.copyToClipboard(this.generateEmbedURL())} 
                            style = {{cursor : 'pointer'}} 
                            variant = 'body2'>
                                {this.generateEmbedURL()}
                        </Typography>
                    </Tooltip>
                </div>
                <Divider style = {{marginTop : '3px', marginBottom : '3px'}} />
                <div style = {{margin : '5px' , borderRadius : '5px', padding : '10px'}}>
                    <Typography style = {{display : 'block'}} variant = 'body2' color = 'primary'>Embed HTML (Replace <em>*** add the id here ***</em> with the record ID or reference ID)</Typography>
                    <Tooltip title = 'Click to copy' placement = 'bottom-start'>
                        <code 
                            style = {{cursor : 'pointer'}}
                            onClick = {(event) => this.copyToClipboard("<iframe title = 'Sainapse Recommendations' width = '100%' height = '700px' src = '" + this.generateEmbedURL() + "'/>")} 
                        >
                            {"<iframe title = 'Sainapse Recommendations' width = '100%' height = '700px' src = '" + this.generateEmbedURL() + "*** add the id here ***'" + "/>"}
                        </code>
                    </Tooltip>
                </div>
                <Divider style = {{marginTop : '3px', marginBottom : '3px'}} />
                <FormControl style = {{ padding : '5px'}}>
                    <FormControlLabel
                        style = {{width : '100%'}}
                        control = {
                            <Switch 
                                color = "primary" 
                                checked={this.state.copy_to_parent} 
                                onChange={(event) => this.updateState("copy_to_parent", event.target.checked)} 
                                name="copy_to_parent" />
                            }
                        label = {<Typography variant = 'body2'>Copy the recommendation to parent window</Typography>}
                    />
                    <FormHelperText>
                        Copies the selected recommendation to the parent window.
                    </FormHelperText>
                </FormControl>
                <Divider style = {{marginTop : '3px', marginBottom : '3px'}} />
                <FormControl style = {{ padding : '5px'}}>
                    <FormControlLabel
                        style = {{width : '100%'}}
                        control = {
                            <Switch 
                                color = "primary" 
                                checked={this.state.show_app_bar} 
                                onChange={(event) => this.updateState("show_app_bar", event.target.checked)} 
                                name="show_app_bar" />
                            }
                        label = {<Typography variant = 'body2'>Show Appplication Bar</Typography>}
                    />
                    <FormHelperText>
                        Shows or hides the application bar at the top of the screen. Useful if you want to hide the application bar when embedded inside an iframe.
                    </FormHelperText>
                </FormControl>
                <Divider style = {{marginTop : '3px', marginBottom : '3px'}} />
                <div style = {{ padding : '5px'}}>
                    <Typography style = {{display : 'block'}} variant = 'overline' color = 'secondary'>Use this feature with caution.</Typography>
                    <Autocomplete
                        style = {{width : '35%'}}
                        id="tags-standard"
                        options={this.getFieldsFromColumns()}
                        value = {this.state.reference_field}
                        onChange = {(event, newValue) => this.updateState('reference_field', newValue)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Reference Field"
                                variant = 'filled'
                                size = 'small'
                            />
                        )}
                    />
                    <Typography style = {{display : 'block'}} variant = 'caption' color = 'secondary'>
                        While embedding if you do not have access to the unique id of the record, you can select another field to filter the record. 
                        If you select a reference field, append the reference field value at the end of the Embed URL.
                    </Typography>
                </div>
            </div>
        )
    }

    renderDeeplinks = () => {
        return (
            <div style = {{width : '100%', maxHeight : '60vh', overflow : 'auto'}}>
                <Typography style = {{marginTop : '5px', marginBottom : '5px'}} variant = 'body2' color = 'textSecondary'>
                    <em>
                       Deeplinks for this screen
                    </em>
                </Typography>
                <Divider style = {{marginTop : '3px', marginBottom : '3px'}} />
                    {/* <div style = {{margin : '5px', borderRadius : '5px', borderBottom : '1px solid rgba(0,0,0,0.12)', padding : '10px'}}>
                        <Typography style = {{display : 'block'}} variant = 'body2' color = 'primary'>URL <em>(With Query Params)</em></Typography>
                        <Tooltip title = 'Click to copy'>
                            <Typography onClick = {(event) => this.copyToClipboard(window.location.origin + '/#' + this.generatePath(this.state.name, this.state.icName, this.state.iuName, 'query'))} style = {{cursor : 'pointer'}} variant = 'body2'>{window.location.origin + '/#' + this.generatePath(this.state.name, this.state.icName, this.state.iuName, 'query')}</Typography>
                        </Tooltip>
                    </div> */}
                    <div style = {{margin : '5px' , borderRadius : '5px', padding : '10px'}}>
                        <Typography style = {{display : 'block'}} variant = 'body2' color = 'primary'>
                            Deeplink to load individual record <em>(Append the record ID at the end)</em>
                        </Typography>
                        <Tooltip title = 'Click to copy'>
                            <Typography 
                                onClick = {(event) => this.copyToClipboard(window.location.origin + '/#' + this.generatePath(this.state.name, this.state.icName, this.state.iuName, 'record'))} 
                                style = {{cursor : 'pointer'}} 
                                variant = 'body2'>
                                    {window.location.origin + '/#' + this.generatePath(this.state.name, this.state.icName, this.state.iuName, 'record')}
                            </Typography>
                        </Tooltip>
                </div>
            </div>
        )
    }

    getRelevantICs = () => {
        let icObjects = []
        this.setState({...this.state, loading_relevant_ICs : true}, () => {
            Actions('http_request', {
                url : "/sainapse/information_channel",
                method : "get",
                data : {}
            }).then(res => {
                let ic_list = res.data.result
                let default_ic = ic_list.find(ic => ic.name === this.state.icName)
                icObjects.push(default_ic)
                if (this.state.reco_sources !== null) {
                    this.state.reco_sources.forEach(source => {
                        let ic_source = ic_list.find(ic => ic.name === source.ic_name)
                        icObjects.push(ic_source)
                    })
                }
                this.setState({...this.state.adding_source, icObjects : icObjects, loading_relevant_ICs : false})
            })
        })
    }

    saveFilters = (filters) => {
        this.setState({...this.state, filters : filters}, () => this.props.update(this.generateConfigFromState()))
    }

    renderFilters = () => {
        console.log("Relevant IC Length : ", this.state.reco_sources.length + 1)
        if (!this.state.loading_relevant_ICs && this.state.icObjects.length !== (this.state.reco_sources.length + 1)) {
            this.getRelevantICs()
        } else if (this.state.loading_relevant_ICs && this.state.icObjects.length !== (this.state.reco_sources.length + 1)) {
            return (
                <div style = {{width : '100%', height : '50vh', padding : '5px', display : 'flex', flexDirection : 'row', justifyContent :'center', alignItems : 'center'}}>
                    <CircularProgress color = "primary"/>
                </div>
            )
        } else if (!this.state.loading_relevant_ICs && this.state.icObjects.length === (this.state.reco_sources.length + 1)) {
            return (
                <div style = {{width : '100%', padding : '5px'}}>
                    <Filter ic_list = {this.state.icObjects} filter_config = {this.state.filters} save_filters = {(filters) => this.saveFilters(filters)}/>
                </div>
            )
        }
    }

    renderExternalSources = () => {
        return (
            <ExternalSources
                screen = {'CaseScreen'}
                external_sources = {this.state.external_sources}
                columns = {this.getFieldsFromColumns()}
                edit = {this.props.editing_id === this.props.config.id}
                update_parent = {(external_sources) => {this.setState({...this.state, external_sources : external_sources})}}
            />
        )
    }

    renderCTA = () => {
        if (this.props.ic_object_list.length !== 0) {
            return (
                <CTAConfig
                    screen_config = {this.props.config}
                    ic_list = {this.props.ic_object_list}
                    selected_ic_list = {this.getSelectedICList()}
                    external_ic = {this.state.icName}
                    external_iu = {this.state.iuName}
                    cta_config = {this.state.cta_config}
                    screen_cta_config  = {this.state.screen_cta_config}
                    edit = {this.props.editing_id === this.props.config.id }
                    set_cta = {(cta_config) => this.setState({...this.state, cta_config : cta_config})}
                    set_screen_cta = {(screen_cta_config) => {
                        console.log('Setting Screen CTA : ', screen_cta_config)
                        this.setState({...this.state, screen_cta_config : screen_cta_config})}
                    }
                />
            )
        }
    }

    getSelectedICList = () => {
        let selected_ic_list = [this.state.icName]
        let additional_ic_list = this.state.reco_sources.map(src => src.ic_name)
        selected_ic_list = [...selected_ic_list, ...additional_ic_list]

        return selected_ic_list
    }

    handleTabChange = (event, newValue) => {
        this.setState({...this.state, setting_tab_index : newValue})
    }

    getCollapseOPenState = () => {
        if (this.state.columns !== null) {
            let columns = this.state.columns
            let column_names = columns.map(col => {
                return col.col_name
            })

            let null_cols = column_names.filter(name => name === null)
            console.log("Column Length : ", columns.length)
            console.log("Column Null Length : ", null_cols.length)
            if (null_cols.length === columns.length) {
                return true
            } else {
                if (this.props.editing_id === this.props.config.id ) {
                    return true
                } else {
                    return this.state.show_settings
                }
            }
        }
    }

    renderButtons = (edit) => {
        //if (!equal(this.props.config, this.generateConfigFromState())) {
        if(edit) {
            return (
                <div>
                    <Typography style = {{marginRight: '10px', color : '#F50157'}} variant = 'caption'>{this.state.error_message}</Typography>
                    <Button
                        style = {{marginRight : '5px'}}
                        variant = 'contained'
                        size = 'small'
                        color = 'primary'
                        onClick = {this.saveSettings}
                    >
                        Save
                    </Button>
                    <Button
                        variant = 'contained'
                        size = 'small'
                        color = 'secondary'
                        onClick = {this.cancelSettings}
                    >
                        Cancel
                    </Button>
                </div>
            )
        }
    }

    renderSettingTabs = () => {
        return (
            <Collapse in = {this.getCollapseOPenState()}>
                <div style = {{width : '100%', padding : '2px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>Settings & Configuration</Typography>
                     {/* {this.renderButtons(this.props.editing_id === this.props.config.id ? true : false)} */}
                </div>
                <AntTabs
                    value={this.state.setting_tab_index}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleTabChange}
                    aria-label="Display Config Tabs"
                >
                    <AntTab label="Queue Configuration" />
                    <AntTab label="Search Configuration" />
                    <AntTab label="View Configuration" />
                    <AntTab label="Embed Configuration" />
                    <AntTab label="Deeplinks" />
                    <AntTab label="Filters" />
                    <AntTab label="ExternalSources" />
                    <AntTab label="Call To Action" />
                </AntTabs>
                {this.renderTabContent()}
            </Collapse>
          )
    }


    renderCaseCard = () => {
        return (
            <Paper style = {{width : '100%', padding : '10px', marginTop : '10px'}}>
                {this.props.editing_id === this.props.config.id ? this.renderCaseEdit() : this.renderCase()}
                {this.renderSettingTabs()}
            </Paper>
        )
    }

    render() { 
        return ( 
            <ThemeProvider theme = {blue_theme}>
                {this.renderCaseCard()}
                {this.addRecoSourceDialog()}
                {this.viewRecoSourceDialog()}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(Case);